import * as React from 'react';
import back_path from '../../img/back_arrow.svg';

export default function BackArrow() {
  return <div className={'back-arrow-hitbox'}>
    <img src={back_path} className={'back-arrow'} alt={'logo'} draggable={'false'} />
    </div>;
};

